class legacyHelper {
	constructor() {
		this.bindPrizmDocViewerPricing();
		this.bindPrizmDocDownloadPage();
		this.bindCramDemo();
	}
	bindPrizmDocViewerPricing() {
		if (document.getElementById('prizmdoc-viewer-pricing')) {
			var url = document.location.toString();
			if (url.match('#')) {
				$('#prizmdoc-viewer-pricing .nav-tabs a[href="#' + url.split('#')[1] + '"]').tab('show');
			}

			var transaction_slider = document.getElementById('transaction-slider');
			// var transaction_range = {
			// 	'min': [200, 800],
			// 	'9.090909091%': [1000, 1000],
			// 	'18.18181818%': [2000, 4000],
			// 	'27.27272727%': [6000, 6000],
			// 	'36.36363636%': [12000, 13000],
			// 	'45.45454545%': [25000, 25000],
			// 	'54.54545455%': [50000, 50000],
			// 	'63.63636364%': [100000, 100000],
			// 	'72.72727273%': [200000, 100000],
			// 	'81.81818182%': [300000, 100000],
			// 	'90.90909091%': [400000, 100000],
			// 	'max': [500000]
			// };
			var transaction_range = {
				'min': [200, 800],
				'16.6666666667%': [1000, 1000],
				'33.3333333333%': [2000, 4000],
				'50%': [6000, 6000],
				'66.6666666667%': [12000, 13000],
				'83.3333333333%': [25000, 25000],
				'max': [50000]
			};
			var pipFormats = {
				'200': '200',
				'1000': '1,000',
				'2000': '2,000',
				'6000': '6,000',
				'12000': '12,000',
				'25000': '25,000',
				'50000': '50,000',
				//'100000': '100,000',
				// '200000': '200,000',
				// '300000': '300,000',
				// '400000': '400,000',
				// '500000': '500,000',
			};
			noUiSlider.create(transaction_slider, {
				range: transaction_range,
				start: 25000,
				connect: [true, false],
				pips: {
					mode: 'values',
					values: [200, 1000, 2000, 6000, 12000, 25000, 50000], //, 100000, 200000, 300000, 400000, 500000],
					density: 500,
					format: {
						to: function (a) {
							return pipFormats[a];
						}
					}
				}
			});



			var pricingMap = {
				'200': {
					'prepaid': 18
				},
				'1000': {
					'prepaid': 89,
					'monthly': 59,
				},
				'2000': {
					'prepaid': 119,
					'monthly': 79,
				},
				'6000': {
					'prepaid': 254,
					'monthly': 169,
				},
				'12000': {
					'prepaid': 434,
					'monthly': 289,
				},
				'25000': {
					'prepaid': 749,
					'monthly': 499,
				},
				'50000': {
					'prepaid': 1199,
					'monthly': 799,
				}
			}

			var monthly = $('#prizmdoc-viewer-pricing #monthly');
			var prepaid = $('#prizmdoc-viewer-pricing #prepaid');
			var sales = $('#prizmdoc-viewer-pricing #sales');
			transaction_slider.noUiSlider.on('update', function () {
				var value = transaction_slider.noUiSlider.get().slice(0, -3);

				var monthlyValue = pricingMap[value]['monthly'];
				var prepaidValue = pricingMap[value]['prepaid'];

				if (monthlyValue) {
					monthly.show();
					monthly.find('.price .value').text(monthlyValue.toLocaleString());
					monthly.find('.number-transactions').text(parseInt(value).toLocaleString());
					monthly.find('.annual-cost .value').text((monthlyValue * 12).toLocaleString());


					sales.show();
					// if(value == '50000') {
					// } else {
					// 	sales.hide();
					// }
				} else {
					monthly.hide();
					sales.hide();
				}

				if (prepaidValue) {
					prepaid.show();
					//sales.hide();
					prepaid.find('.price .value').text(prepaidValue.toLocaleString());
					prepaid.find('.number-transactions').text(parseInt(value).toLocaleString());
				} else {
					prepaid.hide();
					//sales.show();
				}

				$('#prizmdoc-viewer-pricing .noUi-current-value .value').text(parseInt(value).toLocaleString());

			});

			var update = function () {
				var setHeight = 0;
				$('#prizmdoc-viewer-pricing [data-equal-height-1]').each(function () {
					$(this).css('height', '');
				});
				$('#prizmdoc-viewer-pricing [data-equal-height-1]').each(function () {
					setHeight = $(this).outerHeight() > setHeight ? $(this).outerHeight() : setHeight;
				});
				$('#prizmdoc-viewer-pricing [data-equal-height-1]').each(function () {
					$(this).css('height', setHeight + 'px');
				});
			}
			update();
			$('.nav-tabs[data-retain-navigation] a, #prizmdoc-viewer-pricing .nav-tabs a').on('shown.bs.tab', function (e) {
				update();
			});
		}
	}
	bindPrizmDocDownloadPage() {
		if (document.getElementById('prizmdoc-download')) {
			function get_url_param(r) {
				for (var e = window.location.search.substring(1), t = e.split("&"), n = 0; n < t.length; n++) {
					var o = t[n].split("=");
					if (o[0] == r) return o[1]
				}
			}
			var p = get_url_param("platform");
			if (p) {
				var $dl = $("#prizmdoc-download .downloads-item." + p.toLowerCase());
				if ($dl.length) {
					$dl.show();
				}
				else {
					$("#prizmdoc-download .downloads-list-block").html("<div class='alert alert-warning' role='alert'><h4>Platform Not Supported</h4>Sorry, the platform '" + p + "' specified is not a supported platform for PrizmDoc.</div>Need help? <a href='/contact' class='blue'>contact us</a> for assistance.");
				}
			} else {
				$("#prizmdoc-download .downloads-list-block").html("<div class='alert alert-warning' role='alert'><h4>Platform Required</h4>A platform is required in order to view download links for PrizmDoc.<br>Please return to the <a href='/products/prizmdoc/get-it/' class='blue'>PrizmDoc Try It page</a> and select a platform.</div>Need help? <a href='/contact' class='blue'>contact us</a> for assistance.");
			}
		}
	}
	bindCramDemo() {
		$("#twentytwenty").twentytwenty();

		$('.nav-tabs[data-retain-navigation] a').on('shown.bs.tab', function (e) {
			$("#twentytwenty").twentytwenty({
				before_label: 'After',
				after_label: 'Before'
			});
		});
	}
}
window.app.add('legacy', new legacyHelper());


